import { ViewModel,View, ObservableArray } from "binder"
import  { DistrictSaleBenefitsReportView } from "./districtSaleBenefitsReport-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { Enum, IEnumTranslator } from "uicomponents";
import { TranslatorConverter } from "src/TranslatorConverter";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ExcelExporter } from "src/common/utilities";
import { Converters } from "src/uicomponents/converters";

export class DistrictSaleBenefitsReportViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'گزارش سود شعب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<Item>();
        this.from = moment.utc();
        this.until = moment.utc();
        this.enumProvider = new BenefitTypeEnum();
        this.calculationEnumProvider = new BenefitCalculationTypeEnum();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictSaleBenefitsReportView();
    }
    public getTypeId(): string {
        return "VM-CA4CEE80-F810-4F20-9EB9-B8F80EE4C442"
    }

    public set items(v: ObservableArray<Item>) { this._items = v; } public get items(): ObservableArray<Item> { return this._items;} private _items: ObservableArray<Item>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set enumProvider(v: BenefitTypeEnum) { this._enumProvider = v; } public get enumProvider(): BenefitTypeEnum { return this._enumProvider;} private _enumProvider: BenefitTypeEnum;
    public set calculationEnumProvider(v: BenefitCalculationTypeEnum) { this._calculationEnumProvider = v; } public get calculationEnumProvider(): BenefitCalculationTypeEnum { return this._calculationEnumProvider;} private _calculationEnumProvider: BenefitCalculationTypeEnum;
    
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    
    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReportServices/GetDistrictSaleBenefits',{
                From : this.from,
                Until : this.until
            });
            this.items.update(...result.Rows.map((x,i)=>{
                let r = new Item(this);
                r.index = i+1;
                r.productCode = x.ProductCode;
                r.warehouseDistrict = x.FromDistrictName;
                r.saleDistrict = x.ToDistrictName;
                r.amount = x.Amount;
                r.factorNo = x.FactorNo;
                r.factorTime = moment.utc(x.FactorTime);
                r.transactionTime = moment.utc(x.TransactionTime);
                r.type = x.Type;
                r.systemAmount = x.SystemAmount;
                r.twoPercentBenefit = x.TwoPercentBenefit;
                r.additionalAmount = x.AdditionAmount;
                r.benefitCalculationType = x.CalculationType;
                r.finalBenefit = x.FinalBenefit;
                r.purchaseDate = moment.utc(x.PurchaseDate);
                r.purchasePrice = x.PurchasePrice;
                r.lineItemCount = x.LineItemCount;
                r.soldPriceFee = x.SoldPriceFee;
                r.systemPriceFee = x.SystemPriceFee;

                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    exportExcel(){
        let converter = new Converters();
        new ExcelExporter().export('سود شعب.xlsx',this.items.map(x=>{
            return {
                'ردیف':x.index,
                'کد کالا':x.productCode,
                'تاریخ فاکتور':converter.onlyDateNoWeekDayPersianDateConverter(x.factorTime),
                'ساعت فاکتور':converter.onlyTimePersianDateConverter(x.factorTime),
                'تاریخ تایید':converter.onlyDateNoWeekDayPersianDateConverter(x.transactionTime),
                'ساعت تایید':converter.onlyTimePersianDateConverter(x.transactionTime),
                'شماره فاکتور':x.factorNo,
                'نوع':this.enumProvider.GetString(x.type),
                'انبار':x.warehouseDistrict,
                'فروش':x.saleDistrict,
                'تعداد اقلام':x.lineItemCount,
                'فی قیمت سیستمی':x.systemPriceFee,
                'فی قیمت فروش رفته':x.soldPriceFee,
                'قیمت سیستمی':x.systemAmount,
                'قیمت فروش رفته':x.amount,
                'سود دو درصد':x.twoPercentBenefit,
                'بالا بود':x.additionalAmount,
                'تاریخ خرید':converter.onlyDateNoWeekDayPersianDateConverter(x.purchaseDate),
                'ساعت خرید':converter.onlyTimePersianDateConverter(x.purchaseDate),
                'قیمت خرید':x.purchasePrice,
                'روش محاسبه':this.calculationEnumProvider.GetString(x.benefitCalculationType),
                'سود نهایی':x.finalBenefit,
            };
        }))
    }
}

export class Item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set factorTime(v: moment.Moment) { this._factorTime = v; } public get factorTime(): moment.Moment { return this._factorTime;} private _factorTime: moment.Moment;
    public set transactionTime(v: moment.Moment) { this._transactionTime = v; } public get transactionTime(): moment.Moment { return this._transactionTime;} private _transactionTime: moment.Moment;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set warehouseDistrict(v: string) { this._warehouseDistrict = v; } public get warehouseDistrict(): string { return this._warehouseDistrict;} private _warehouseDistrict: string;
    public set saleDistrict(v: string) { this._saleDistrict = v; } public get saleDistrict(): string { return this._saleDistrict;} private _saleDistrict: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount;} private _amount: number;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type;} private _type: number;
    public set factorNo(v: number) { this._factorNo = v; } public get factorNo(): number { return this._factorNo;} private _factorNo: number;
    public set systemAmount(v: number) { this._systemAmount = v; } public get systemAmount(): number { return this._systemAmount;} private _systemAmount: number;
    public set twoPercentBenefit(v: number) { this._twoPercentBenefit = v; } public get twoPercentBenefit(): number { return this._twoPercentBenefit;} private _twoPercentBenefit: number;
    public set additionalAmount(v: number) { this._additionalAmount = v; } public get additionalAmount(): number { return this._additionalAmount;} private _additionalAmount: number;
    public set finalBenefit(v: number) { this._finalBenefit = v; } public get finalBenefit(): number { return this._finalBenefit;} private _finalBenefit: number;
    public set benefitCalculationType(v: number) { this._benefitCalculationType = v; } public get benefitCalculationType(): number { return this._benefitCalculationType;} private _benefitCalculationType: number;
    public set purchaseDate(v: moment.Moment) { this._purchaseDate = v; } public get purchaseDate(): moment.Moment { return this._purchaseDate;} private _purchaseDate: moment.Moment;
    public set purchasePrice(v: number) { this._purchasePrice = v; } public get purchasePrice(): number { return this._purchasePrice;} private _purchasePrice: number;
    public set lineItemCount(v: number) { this._lineItemCount = v; } public get lineItemCount(): number { return this._lineItemCount;} private _lineItemCount: number;
    public set soldPriceFee(v: number) { this._soldPriceFee = v; } public get soldPriceFee(): number { return this._soldPriceFee;} private _soldPriceFee: number;
    public set systemPriceFee(v: number) { this._systemPriceFee = v; } public get systemPriceFee(): number { return this._systemPriceFee;} private _systemPriceFee: number;
    
}

export class BenefitTypeEnum extends Enum implements IEnumTranslator{
 
    constructor() {
        super();
        this.values = [1,2,3,4];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateDistrictBenefitType(value);
    }

}

export class BenefitCalculationTypeEnum extends Enum implements IEnumTranslator{
 
    constructor() {
        super();
        this.values = [1,2];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateDistrictBenefitCalculationType(value);
    }

}